import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Select } from '../../../../../../../../CommonComponents/OPL/Select/Select/Select';
import { useAccountFormContext } from '../../context/useAccountFormContext';

export const MortgageType = () => {
  const formBag = useFormContext();

  const {
    options: { mortgageTypeOptions },
  } = useAccountFormContext();

  return (
    <Controller
      control={formBag.control}
      name="bankAccount.MortgageType"
      render={({ field: { value, onChange, ref } }) => (
        <Select
          innerRef={ref}
          label="Mortgage Type"
          value={mortgageTypeOptions.find(({ value: v }) => value === v)}
          options={mortgageTypeOptions}
          onChange={opt => onChange(opt?.value)}
          isPortal
        />
      )}
    />
  );
};
